export default {
  en: {
    misc: {
      about: 'About this Emerging Threat',
      more: 'Learn more about this Emerging Threat',
    },
    threatTypes: {
      software: 'Software',
      geopolitical: 'Geopolitical',
      ransomware: 'Ransomware',
      esg: 'ESG',
      other: 'Other',
    },
    status: {
      investigating: 'Investigating',
      remediating: 'Remediating',
      resolved: 'Resolved',
      unaffected: 'Unaffected',
      unanswered: 'No response',
      active: 'Active',
      inactive: 'Inactive',
    },
    placeholders: {
      emptyTitle: 'Emerging Threats',
      emptyDescription: 'No Emerging Threats',
      errorTitle: 'Error retrieving answers',
      errorDescription:
        'An error ocurred while attempting to retrieve the Emerging Threat questions answers',
      noThreatSelectedTitle: 'No Emerging Threat selected',
      noThreatSelectedTitleDescription:
        'Select an Emerging Threat from the left sidebar to see more',
      threatNotFoundTitle: 'Emerging Threat not found',
      threatNotFoundDescription: 'Emerging Threat could not be found. Select one from the sidebar.',
    },
    activityItems: {
      questionNumber: 'Q.{index}',
      yes: 'Yes',
      no: 'No',
      unanswered: 'Unanswered',
      emergingThreatsAnswerChanged:
        '{name} changed {context} answer {prevValue} to {newValue} for {question}',
      emergingThreatsAnswerChangedConnection:
        '{name} changed {context} answer {prevValue} to {newValue} for {question} from Emerging Threat {threat}',
      emergingThreatsAnswerNotesChanged: '{name} changed {context} answer notes for {question}',
      emergingThreatsAnswerNotesChangedConnection:
        '{name} changed {context} answer notes for {question} from Emerging Threat {threat}',
      emergingThreatsAnswerEvidenceAdded: '{name} added {fileName} as evidence for {question}',
      emergingThreatsAnswerEvidenceAddedConnection:
        '{name} added {fileName} as evidence for {question} from Emerging Threat {threat}',
      emergingThreatsAnswerEvidenceReplaced:
        '{name} updated {fileName} evidence to a new version for {question}',
      emergingThreatsAnswerEvidenceReplacedConnection:
        '{name} updated {fileName} evidence to a new version for {question} from Emerging Threat {threat}',
      emergingThreatsAnswerEvidenceRemoved: '{name} removed {fileName} as evidence for {question}',
      emergingThreatsAnswerEvidenceRenamed:
        '{name} renamed {oldFileName} evidence to {newFileName} for {question}',
      emergingThreatsAnswerEvidenceRemovedConnection:
        '{name} removed {fileName} as evidence for {question} from Emerging Threat {threat}',
      emergingThreatsAnswerEvidenceRenamedConnection:
        '{name} renamed {oldFileName} evidence to {newFileName} for {question} from Emerging Threat {threat}',
      emergingThreatsResponseStatusChanged:
        '{name} changed {context} response status {prevValue} to {newValue}',
      emergingThreatsResponseStatusChangedConnection:
        '{name} changed {context} response status {prevValue} to {newValue} for Emerging Threat {threat}',
      userAssigned: {
        other: '{name} assigned {assignee} to this Emerging Threat',
        self: '{name} self-assigned to this Emerging Threat',
      },
      userAssignedConnection: {
        other: '{name} assigned {assignee} to Emerging Threat {threat}',
        self: '{name} self-assigned to Emerging Threat {threat}',
      },
      userUnassigned: {
        other: '{name} unassigned {assignee} from this Emerging Threat',
        self: '{name} removed their assignment from this Emerging Threat',
      },
      userUnassignedConnection: {
        other: '{name} unassigned {assignee} from Emerging Threat {threat}',
        self: '{name} removed their assignment from Emerging Threat {threat}',
      },
    },
    threatsTab: {
      lastUpdated: 'Last updated {date}',
      responseTab: 'Response',
      discussionTab: 'Discussion',
      supplierStatus: 'Status',
      questions: 'Questions',
      errorTitle: 'Emerging Threats',
      errorDescription: 'Failed fetching Emerging Threats',
      questionRow: {
        questionNumber: 'Q.{0}',
        answerTooltip: 'Question answer',
        evidenceTooltip: 'Evidence uploaded',
        lastModified: 'Last modified {date}',
        answered: 'Answered',
        unanswered: 'Unanswered',
      },
    },
  },
};
